import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 3a6 6 0 0 0 12 0","key":"svg-0"}],["path",{"d":"M6 15a6 6 0 1 0 12 0a6 6 0 1 0 -12 0","key":"svg-1"}]]

const IconZodiacTaurus = createReactComponent('outline', 'zodiac-taurus', 'ZodiacTaurus', __iconNode);

export default IconZodiacTaurus;